// extracted by mini-css-extract-plugin
export default {"selectFilters":"OCXuk","filterField":"tt1V1","propertyFilter":"jt7hh","greenText":"liq_G"};